import { useEffect, useState } from "react";
import { api, formatRupiah, errMsg } from "@/lib/api";
import { Plus, X } from "lucide-react";

export default function Inventory() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", category: "Bunga", qty: 1, condition: "Baik", location: "Gudang Utama", value: 0, is_rental: false, rental_price: 0 });
  const [err, setErr] = useState("");

  async function load() {
    const { data } = await api.get("/inventory");
    setList(data);
  }
  useEffect(() => { load(); }, []);

  async function create(e) {
    e.preventDefault();
    try {
      await api.post("/inventory", { ...form, qty: Number(form.qty), value: Number(form.value), rental_price: Number(form.rental_price) });
      setOpen(false); setForm({ name: "", category: "Bunga", qty: 1, condition: "Baik", location: "Gudang Utama", value: 0, is_rental: false, rental_price: 0 });
      await load();
    } catch (ex) { setErr(errMsg(ex)); }
  }

  return (
    <div className="p-4 sm:p-8 space-y-5">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-serif-display font-bold">Inventory & Aset</h1>
          <p className="text-sm text-[#536263]">Katalog item, ringlock, dan rental</p>
          <div className="mt-2 h-px w-12 bg-[#B87333]"></div>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary" data-testid="inv-add-btn"><Plus size={16} />Tambah Item</button>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="inventory-list">
        {list.map(i => (
          <div key={i.id} className="card-editorial p-4">
            <div className="flex items-center justify-between">
              <span className="chip bg-[#F7EFE8] text-[#B87333]">{i.category}</span>
              {i.is_rental && <span className="chip bg-[#0F5257] text-white">Rental</span>}
            </div>
            <h3 className="font-serif-display text-lg font-semibold mt-2">{i.name}</h3>
            <div className="text-sm text-[#536263] space-y-1 mt-1">
              <div>Qty: <span className="font-mono-num font-semibold">{i.qty}</span> · {i.condition}</div>
              <div>Lokasi: {i.location}</div>
              {i.value !== undefined && <div>Nilai: <span className="font-mono-num text-[#0F5257]">{formatRupiah(i.value)}</span></div>}
              {i.is_rental && i.rental_price !== undefined && <div>Sewa/hari: <span className="font-mono-num text-[#B87333]">{formatRupiah(i.rental_price)}</span></div>}
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="col-span-full text-center p-12 text-[#8A999A]">Belum ada item</div>}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={() => setOpen(false)}>
          <form onSubmit={create} onClick={e => e.stopPropagation()} className="bg-white rounded-t-2xl sm:rounded-2xl w-full sm:max-w-md p-5 space-y-3" data-testid="inv-form">
            <div className="flex items-center justify-between">
              <h3 className="font-serif-display text-xl font-bold">Item Inventory Baru</h3>
              <button type="button" onClick={() => setOpen(false)}><X /></button>
            </div>
            <input required placeholder="Nama Item" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-[#E2DDD3] rounded-lg px-3 h-11" />
            <div className="grid grid-cols-2 gap-3">
              <select value={form.category} onChange={e => setForm({...form, category: e.target.value})} className="border border-[#E2DDD3] rounded-lg px-3 h-11">
                {["Bunga","Properti","Styrofoam","Lighting","Scaffolding","Lainnya"].map(x => <option key={x}>{x}</option>)}
              </select>
              <select value={form.condition} onChange={e => setForm({...form, condition: e.target.value})} className="border border-[#E2DDD3] rounded-lg px-3 h-11">
                {["Baik","Perlu Perbaikan","Rusak"].map(x => <option key={x}>{x}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input type="number" placeholder="Qty" value={form.qty} onChange={e => setForm({...form, qty: e.target.value})} className="border border-[#E2DDD3] rounded-lg px-3 h-11" />
              <input placeholder="Lokasi" value={form.location} onChange={e => setForm({...form, location: e.target.value})} className="border border-[#E2DDD3] rounded-lg px-3 h-11" />
            </div>
            <input type="number" placeholder="Nilai (Rp)" value={form.value} onChange={e => setForm({...form, value: e.target.value})} className="w-full border border-[#E2DDD3] rounded-lg px-3 h-11" />
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={form.is_rental} onChange={e => setForm({...form, is_rental: e.target.checked})} />
              <span className="text-sm">Tersedia untuk rental</span>
            </label>
            {form.is_rental && (
              <input type="number" placeholder="Harga sewa per hari (Rp)" value={form.rental_price} onChange={e => setForm({...form, rental_price: e.target.value})} className="w-full border border-[#E2DDD3] rounded-lg px-3 h-11" />
            )}
            {err && <div className="text-sm text-red-700">{err}</div>}
            <button type="submit" className="btn-primary w-full" data-testid="inv-submit">Simpan</button>
          </form>
        </div>
      )}
    </div>
  );
}
